<template>
  <v-combobox
    v-model="model"
    :label="label"
    :items="items"
    item-text="name"
    :search-input.sync="search"
    item-value="id"
    :clearable="(clearable_ ? true : false)"
    dense
    chips
    :flat="solo"
    :solo="solo"
    :multiple="(multiple_ ? true : false)"
    :outlined="!solo"
    :menu-props="{ auto: true, overflowY: true }"
    height="33px"
    :hint="hint"
    @focus="focus"
    @blur="blur"
  >
    <template v-slot:selection="data">
      <v-chip
        style="height: 22px !important;"
      >
        {{ data.item.name }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
  import General from '../../../../../Mixins/general'

  export default {
    name: 'Combobox',
    props: ['type', 'hint', 'label', 'clearable_', 'multiple_', 'filter', 'default', 'value', 'solo', 'edit'],
    data: () => ({
      items: [],
      search: null,
      model: null,
      setInit: null,
    }),
    mixins: [General],
    watch: {
      filter (val, oldVal) {
        if (val !== oldVal) {
          this.filter = val
          // this.getItems()
        }
      },
      value (val, oldVal) {
        this.blur()
      },
      edit (val, oldVal) {
        this.blur()
      },
      model () {
        this.blur()
      },
    },
    activated: function () {
      this.blur()
    },
    mounted () {
      this.getItems()
    },
    methods: {
      setData (id) {
        if (this.items.length > 0) {
          this.setInit = id
          this.getItems()
        } else {
          var index = this.items.findIndex(x => x.id === id)
          this.model = this.items[index]
        }
      },
      clear () {
        this.model = null
      },
      focus () {
        this.getItems()
      },
      blur () {
        if (typeof (this.search) === 'undefined') {
          this.search = null
          this.model = null
          this.$emit('input', null)
        } else {
          if (this.model) {
            if (this.multiple_ || this.default) {
              this.$emit('input', this.model)
            } else {
              this.$emit('input', this.model.id)
            }
          }
        }
      },
      getItems () {
        var app = this
        var data = {}
        data.search = this.search
        data.page = this.currentPage
        data.select = this.type
        data.filter = this.filter
        app.$axios.get(this.$endpoint + 'getdata', {
          params: data,
        })
          .then(res => {
            res = res.data
            if (res.last_page > app.page) {
              app.page++
            }
            app.items = []
            app.items = res.data
            // app.items = [
            //   ...app.items,
            //   ...Array.from(res.data),
            // ]

            if (!app.search && !app.multiple_) {
              app.model = app.items[0]
              app.$emit('input', app.model.id)
            }
            if (app.default) {
              app.items.map(function (value, index) {
                if (value.id === app.default) {
                  app.model = app.items[index]
                }
              })
            }
            if (app.setInit) {
              var index = app.items.findIndex(x => x.id === app.setInit)
              app.model = app.items[index]
              app.$emit('input', app.setInit)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
